import dataEventModel from './data-event-model';
import { CHANGE_TYPE_LOCATION_KEY, ChangeTypeByKey, EmptyQueue } from './helpers';
import { EventContext, EventQueue } from './types';

const dataEventTrigger = () => (() => {
  const queue: EventQueue[] = [];
  let isProcessing = false;

  function next(context: EventContext) {
    if (queue.length === 0 || isProcessing) {
      return;
    }

    isProcessing = true;

    const { evt, callback }: EventQueue = queue.shift() ?? EmptyQueue;
    const { currentRecord } = context;

    const queueEvent = dataEventModel();

    const isFormValue = evt.name === ChangeTypeByKey.key;
    const isProjectField = evt.name === ChangeTypeByKey['@project'];

    if (isFormValue) {
      currentRecord.form_values![evt.key] = evt.value;
    }

    if (isProjectField) {
      currentRecord.project_id = evt.value.project_id;
    }

    if (!isFormValue && typeof evt.field !== 'object') {
      currentRecord[evt.field] = evt.value;
    }
    if (evt.name === ChangeTypeByKey[CHANGE_TYPE_LOCATION_KEY]) {
      currentRecord.latitude = evt.value.latitude;
      currentRecord.longitude = evt.value.longitude;
    }

    const valuesForConditions = {
      toJSON: () => (isFormValue ? currentRecord.form_values : currentRecord),
    };

    const updatedContext = { ...context, currentRecord };

    const handler = (results: any[]) => {
      queueEvent.processExpressions(results, (result: any) => {
        callback(result);

        context.onChange(currentRecord);

        isProcessing = false;

        next(updatedContext);
      },
      updatedContext);
    };

    context.engine.evaluateDataEvent(
      context.form,
      valuesForConditions,
      context.getFeatureVariables,
      evt,
      handler,
    );
  }

  return {
    current: ({ ...eventItems }: EventQueue, context: EventContext) => {
      const { evt, callback } = eventItems;

      queue.push({ evt, callback });
      next(context);
    },
  };
})();

export default dataEventTrigger;
